import React from 'react';
import { Button, Form, Input, Space, Flex, Title } from '@bb/elements-web';
import styled from 'styled-components';
import { useSingleAccessSetupContext } from '../context/SingleAccessSetupContext';
import { StyledCard, StyledText } from './styledComponents';

export default function SingleAccessDefaultCard() {
  const { submitProfile, hasUserData } = useSingleAccessSetupContext();

  const submit = async (data: { email: string }) => {
    await submitProfile(data.email);
  };

  return (
    <Flex vertical gap={32} align="center">
      {hasUserData && (
        <>
          <StyledCard $bordered>
            <Space size={8} direction="vertical">
              <Title dataCy="single-access-signup-title" level={4} margin={0}>
                Sign up for Single Access
              </Title>
              <StyledText size="large" $secondary>
                Enter your email to get started and create your account.
              </StyledText>
            </Space>
            <StyledForm
              dataCy="single-access-signup-form"
              layout="vertical"
              onFinish={submit}
            >
              <StyledFormItem
                label="Email"
                name="email"
                rules={[{ required: true, message: 'Please input your email' }]}
              >
                <Input dataCy="single-access-email-input" />
              </StyledFormItem>
              <StyledFormItem>
                <StyledButton
                  dataCy="single-access-continue-button"
                  type="primary"
                  htmlType="submit"
                >
                  Continue
                </StyledButton>
              </StyledFormItem>
            </StyledForm>
          </StyledCard>
          <StyledContainer>
            <StyledText size="large" $alignCenter>
              By clicking “Continue” you acknowledge that you have read,
              understood, and agree to the{' '}
              <a
                href="https://www.brokerbay.com/terms-of-service"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms of Service
              </a>
              .
            </StyledText>
          </StyledContainer>
        </>
      )}
    </Flex>
  );
}

const StyledContainer = styled.div`
  width: 343px;
  max-width: 90%;
  min-width: 320px;
  text-align: center;
`;

const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  margin-top: 8px;

  .ant-input,
  .ant-form-item-label > label {
    font-size: 16px;
  }
`;

const StyledFormItem = styled(Form.Item)`
  width: 100%;
  margin-bottom: 0;
`;

const StyledButton = styled(Button)`
  width: 100%;
  font-size: 16px;
  padding-top: 0;
  padding-bottom: 0;
`;
